import Chart from "react-apexcharts";
import { colors } from "../../global";

const TicketsByVertical = ({ data }) => {
  const chartData = data;
  if (!chartData || !chartData.categories) return null;

  const chartColors = [
    colors.primary,
    colors.accent,
    colors.tertiary,
    "#FF9800",
    "#4CAF50",
    "#9C27B0",
  ];

  return (
    <>
      <h2 className="text-lg font-semibold mb-4">
        Tickets by Vertical per Month
      </h2>
      <Chart
        options={{
          chart: { type: "line", toolbar: { show: false } },
          stroke: { curve: "smooth", width: 3 },
          xaxis: {
            categories: chartData.categories,
            title: { text: "Vertical" },
            labels: { rotate: -25, style: { fontSize: "12px" } },
          },
          yaxis: {
            title: { text: "Total Tickets" },
            labels: { formatter: (v) => Math.round(v) },
          },
          legend: {
            position: "top",
            horizontalAlign: "center",
            fontSize: "13px",
          },
          colors: chartColors.slice(0, chartData.series.length),
          markers: { size: 4 },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: (v) => `${Math.round(v).toLocaleString()} tickets`,
            },
          },
          dataLabels: {
            enabled: true,
            formatter: (v) => Math.round(v).toLocaleString(),
            offsetY: -10,
            style: {
              fontSize: "12px",
              fontWeight: "bold",
            },
          },
        }}
        series={chartData.series}
        type="line"
        height={350}
      />
    </>
  );
};

export default TicketsByVertical;
